export const ALLOWED_CODE_UPLOAD_MIME_TYPES = 'application/zip,application/x-zip-compressed,text/plain';
export const ALLOWED_IMAGE_UPLOAD_MIME_TYPES = 'image/jpeg,image/png';
export const ARCHIVE = 'ARCHIVE';
export const APPLICATIONS = {
    facebook: {
        id: 2,
        pivot: { synchronized: true, syndicated: true },
    },
    snagshout: {
        id: 1,
        pivot: { synchronized: true, syndicated: true },
    },
};
export const CAMPAIGN_TYPES = {
    COUPON: 'coupon-code',
    FACEBOOK: 'facebook',
    IMAGE: 'image',
    LANDING: 'landing',
    REBATE: 'classic-rebate',
    RESEARCH: 'research',
    REVIEW: 'review',
    REWARD: 'inserts',
    SNAGSHOUT: 'snagshout',
    SOCIAL: 'social',
    TESTIMONIAL: 'testimonial',
    VIDEO: 'video',
};
export const CC_REBATE_FEE = 0.06;
export const CREATION_LINK = '/creation/start';
export const CREATION_TYPES = {
    KWB: 'kwb',
    LANDING_PAGE: 'landing-page',
    REBATE: 'rebate',
    SYNDICATED: 'syndicated',
};
export const DUPLICATE = 'DUPLICATE';
export const END = 'END';
export const FEATURE = 'FEATURE';
export const MAX_MEDIA_PER_CAMPAIGN = 6;
export const MIN_REBATE = 3;
export const MIN_ADMIN_REBATE = 2;
export const MIN_RESEARCH_REBATE = 0.5;
export const MIN_REWARD_REBATE = 1;
export const MONEY_OFF = 'Money off';
export const PAUSE = 'PAUSE';
export const PERCENT_OFF = 'Percentage off';
export const PROMOTION_TYPE = {
    MULTI_USE: 'MULTI_CODE',
    REBATE: 'REBATE',
    REWARD_REBATE: 'REWARD_REBATE',
    SINGLE_USE: 'SINGLE_USE',
    URL: 'URL',
};
export const START = 'START';
export const STATE = {
    ARCHIVED: 'ARCHIVED',
    DRAFT: 'DRAFT',
    PAUSED: 'PAUSED',
    PUBLISHED: 'PUBLISHED',
    STOPPED: 'STOPPED',
};
export const STATUS = {
    ARCHIVED: 'ARCHIVED',
    DRAFT: 'DRAFT',
    ENDED: 'ENDED',
    FUTURE: 'FUTURE',
    LIVE: 'LIVE',
    PAUSED: 'PAUSED',
    PENDING: 'PENDING',
};
export const STEPS = {
    ADDONS: 'addons',
    CONFIRMATION: 'confirmation',
    EMAIL: 'email',
    KEYWORD_BOOST: 'keyword-boost',
    LANDING: 'landing',
    OFFER: 'offer',
    PREVIEW: 'preview',
    PRODUCT: 'product',
    START: 'start',
};
export const TYPES = {
    LANDING_PAGE: 'LANDING-PAGE',
    REBATE: 'REBATE',
    STANDARD: 'STANDARD',
    SYNDICATION: 'SYNDICATION',
};
export const VIDEO = 'video';
